// extracted by mini-css-extract-plugin
export default {"VerifyIcon":"button_VerifyIcon__Fvna+"};